import { memo } from 'react';

import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

const OfferCardSkeleton = ({ totalFields = 3 }) => {
  const renderFields = (length) =>
    Array.from({ length }, (_, key) => (
      <Stack
        key={key}
        spacing="16px"
        width={`${100 / length}%`}
      >
        <Skeleton
          height={75}
          width="75%"
        />
        <Skeleton
          height={20}
          width="75%"
        />
        <Skeleton
          height={15}
          width="75%"
        />
        <Skeleton
          height={20}
          width="25%"
        />
        <Skeleton
          height={20}
          width="50%"
        />
        <Skeleton
          height={20}
          width="50%"
        />
        <Skeleton
          height={50}
          width="75%"
        />
      </Stack>
    ));

  return (
    <Stack
      direction="row"
      spacing="16px"
      width="100%"
    >
      {renderFields(totalFields)}
    </Stack>
  );
};

OfferCardSkeleton.propTypes = {
  totalFields: PropTypes.number
};

export default memo(OfferCardSkeleton);
